const locale = {
  DUPLICATE_OF: 'Duplicato di',
  DUPLICATED_BY: 'Duplicato da',
  RELATED_TO: 'Correlato a',
  SPLIT_TO: 'Dividi in',
  SPLIT_FROM: 'Diviso da',
  BLOCKED_BY: 'Bloccato da',
  BLOCKS: 'Blocchi',
  MORE_THAN: 'Maggiore di',
  LESS_THAN: 'Meno di',
  OPEN: 'Aprire',
  IN_PROGRESS: 'In corso',
  ON_HOLD: 'In attesa',
  COMPLETE: 'Completare',
  'home.built': 'Progettato per semplificare la gestione della manutenzione',
  home_description:
    'Quando lavagne e post-it creano caos e hai bisogno di un software CMMS abbastanza semplice da utilizzare per il tuo team, prova {{shortBrandName}}',
  try_grash: 'Prova {{shortBrandName}}',
  login: 'Login',
  start_trial: 'Inizia una prova gratuita',
  'home.what': 'Che cosa',
  'home.you_will_have': 'Avrai',
  'home.you_will_have_description':
    "Crea flussi di lavoro efficienti e affidabili che ti consentono di avere il controllo della manutenzione. Genera, assegna e monitora gli ordini di lavoro. Controlla l'inventario. E ottieni report automatizzati affidabili che migliorano la visibilità e creano responsabilità.",
  key_features: 'Caratteristiche principali',
  key_features_description:
    'Alcune delle caratteristiche che rendono {{shortBrandName}} uno dei migliori CMMS disponibili oggi',
  contribute: 'Contribuire',
  work_orders: 'Ordini di lavoro',
  request_system: 'Sistema di richiesta di lavoro',
  mobile_app: 'Applicazione mobile',
  asset_management: 'Gestione delle risorse',
  preventive_maintenance: 'Manutenzione preventiva',
  parts_inventory: 'Inventario delle parti',
  custom_dashboards: 'Dashboard personalizzate',
  'work-orders.title': 'Gestisci i tuoi ordini di lavoro come un capo',
  'work-orders.description.short':
    'Visualizza e gestisci tutte le tue attività',
  'work-orders.descriptions.0':
    'Stanco di montagne di scartoffie e ordini di lavoro persi? Tutti questi elementi persi incidono direttamente sui profitti e sulla tua reputazione.',
  'work-orders.descriptions.1':
    'Con {{shortBrandName}} puoi organizzare facilmente e rapidamente tutti i tuoi ordini di lavoro, i tuoi PM e le altre attività del tuo team in un database centralizzato accessibile ovunque e su qualsiasi dispositivo.',
  'work-orders.checks.0':
    'Visualizza tutte le tue attività, inclusi WO, PM e richieste di lavoro',
  'work-orders.checks.1':
    'Imposta la priorità delle attività in modo che il lavoro giusto venga svolto per primo.',
  'work-orders.checks.2':
    'Visualizza un calendario delle attività attuali e future.',
  'work-orders.checks.3':
    'Visualizza gli incarichi di lavoro con informazioni critiche come informazioni sulle risorse, data di scadenza, priorità e altro ancora.',
  'work-orders.checks.4':
    'Visualizza i KPI critici, come il lavoro effettivamente completato, il tempo impiegato e il lavoro pianificato rispetto a quello non pianificato.',
  'work-requests.title':
    'Un sistema semplificato di richiesta di lavoro mobile',
  'work-requests.descriptions.0':
    'Stanco di utilizzare il vecchio sistema telefonico ed e-mail che si traduce in biglietti PERSI, continue interruzioni giornaliere e lavoro duplicato?',
  'work-requests.descriptions.1':
    'La soluzione di gestione della manutenzione di {{shortBrandName}} consente a chiunque tu autorizzi di segnalare un problema al tuo reparto di manutenzione semplicemente scansionando un codice QR (codice a barre) o visitando un URL e digitando la propria richiesta tramite i propri dispositivi mobili.',
  'work-requests.checks.0': 'Non perdere mai più il lavoro.',
  'work-requests.checks.1':
    'Riduci fino al 34% il tempo impiegato per gestire le richieste di lavoro.',
  'work-requests.checks.2':
    'Riduci fino al 41% i tempi di comunicazione con i richiedenti (chiamate, e-mail, SMS).',
  'mobile-app.title':
    "Un'app CMMS mobile che potenzia il tuo team di manutenzione",
  'mobile-app.descriptions.0':
    "Grazie all'utilizzo della nostra app mobile Android, i nostri clienti possono beneficiare di una migliore organizzazione, comunicazione, responsabilità e produttività fino al 30% in più nell'intero team di manutenzione.",
  'mobile-app.descriptions.1':
    'Dal proprio dispositivo portatile, chiunque nel tuo team di manutenzione può:',
  'mobile-app.checks.0': 'Visualizzare gli ordini di lavoro e i PM assegnati.',
  'mobile-app.checks.1':
    'Registra i loro ordini di lavoro in meno di 60 secondi',
  'mobile-app.checks.2':
    'Ricevi comunicazioni immediate tramite notifiche push ed e-mail.',
  'mobile-app.checks.3': 'Avvia nuovi ordini di lavoro mentre sei sul campo.',
  'mobile-app.checks.4':
    'Rispondere e registrare i problemi mentre si lavora effettivamente sul problema',
  'mobile-app.checks.5':
    'Cerca informazioni critiche sulle risorse durante la diagnosi di un problema.',
  'eam.title': 'Gestione delle risorse aziendali',
  'eam.description.short': 'Conosci le tue risorse',
  'eam.descriptions.0':
    'Frustrato nel tentativo di organizzare il disordine caotico delle attrezzature aziendali, chiedendoti se le attrezzature sono state adeguatamente mantenute, non sapendo quanto costa la loro manutenzione e tutti gli altri grattacapi che derivano dalla gestione delle risorse?',
  'eam.descriptions.1':
    'Il modulo Enterprise Asset Management di {{brandName}} può essere utilizzato per un numero di asset compreso tra 10 e 1.000.000, consentendoti di monitorare esattamente ciò che desideri, nel modo desiderato, in una struttura ad albero facile da usare e ricercabile.',
  'eam.checks.0':
    'Conosci lo stato di salute dei tuoi beni in ogni momento e quanto ti costano',
  'eam.checks.1': 'Visualizza registri di manutenzione completi e dettagliati.',
  'eam.checks.2':
    'Tieni traccia solo di ciò che desideri con campi personalizzati illimitati',
  'eam.checks.3':
    'Organizza le tue risorse in una chiara gerarchia genitore-figlio',
  'eam.checks.4':
    'Trova informazioni in modo rapido e semplice con i codici QR (codici a barre)',
  'eam.checks.5':
    'Ricevi dati sulle risorse in tempo reale grazie alla connettività dei sensori.',
  'pm.title': 'Un programma di manutenzione preventiva efficace',
  'pm.descriptions.0':
    'Smetti di sprecare ore preziose distribuendo manualmente le checklist di Project Management e monitorando il tuo team per assicurarti che il lavoro venga svolto.',
  'pm.descriptions.1':
    '{{shortBrandName}} ti consente di automatizzare facilmente la pianificazione della manutenzione preventiva, in modo che il lavoro giusto venga automaticamente consegnato al momento giusto, al tecnico giusto per la risorsa giusta.',
  'pm.checks.0':
    'Automatizza la programmazione della manutenzione preventiva su base giornaliera, settimanale, mensile, annuale o in base a eventi o letture dei contatori.',
  'pm.checks.1':
    'Notifiche automatiche push ed e-mail quando viene creato o è in scadenza un messaggio privato.',
  'pm.checks.2':
    'Il nostro Calendario, facile da usare, ti consente di visualizzare tutti i lavori aperti e le prossime scadenze PM.',
  'pm.checks.3': 'Trascina e rilascia per modificare la data di scadenza.',
  'pm.checks.4':
    'Una volta completata la manutenzione preventiva, il lavoro viene automaticamente registrato nel registro di manutenzione della risorsa.',
  'pm.checks.5': 'Richiede poca o nessuna formazione per essere utilizzato.',
  'part.title': 'Ottieni il controllo del tuo inventario di pezzi di ricambio',
  'part.description.short': 'Scopri quando i tuoi pezzi di ricambio finiranno',
  'part.descriptions.0':
    'Non sai quali ricambi hai in magazzino o dove vengono utilizzati? Non sai quando i tuoi ricambi si esauriranno o se i tuoi tecnici avranno quelli necessari per svolgere il loro lavoro?',
  'part.descriptions.1':
    'Abbiamo progettato la gestione dei componenti di {{shortBrandName}} per risolvere questi problemi e molto altro ancora:',
  'part.checks.0':
    'Ricevi notifiche push ed e-mail immediate quando la quantità di un componente è bassa. Mantieni il numero corretto di componenti in magazzino ricevendo notifiche push/e-mail immediate e automatiche quando la quantità di un componente è inferiore a una soglia personalizzata.',
  'part.checks.1':
    'I tecnici sanno immediatamente se il componente è disponibile in magazzino tramite un ordine di lavoro. Se il componente non è disponibile, possono facilmente verificare la disponibilità in altre sedi.',
  'part.checks.2':
    "Monitoraggio automatico dell'utilizzo dei componenti. Man mano che gli ordini di lavoro o i PM utilizzano componenti, l'inventario verrà aggiornato automaticamente per riflettere i componenti utilizzati.",
  'part.checks.3':
    "Conoscere l'utilizzo delle parti. Visualizzare il registro delle parti per vedere dove e da chi viene utilizzata la parte",
  'part.checks.4':
    'Elimina le parti inutilizzate. Scopri quando una parte è diventata obsoleta.',
  'part.checks.5':
    'Report in tempo reale. Scopri quali parti vengono utilizzate, dove e quanto ti costano.',
  'part.checks.6':
    'Ottimizza i livelli di stock. Visualizza immediatamente le previsioni per un componente per vedere quanti componenti potrebbero essere utilizzati entro il prossimo anno.',
  'part.checks.7':
    'Ricerca tramite codice a barre. Rendi il tuo inventario facile da tracciare e accedere con codici QR personalizzati.',
  'dashboard.title': 'I tuoi dati, a modo tuo con dashboard personalizzate',
  'dashboard.descriptions.0':
    'Ammettiamolo, il primo passo per migliorare le proprie operazioni è conoscere il buono, il cattivo e il brutto.',
  'dashboard.descriptions.1':
    'Con le dashboard personalizzate di {{shortBrandName}} puoi finalmente iniziare a comprendere quel nefasto "buco nero della manutenzione" e iniziare a mettere in atto piani basati sui dati, con conseguente riduzione dei costi di manodopera, diminuzione dei tempi di inattività e altro ancora.',
  'dashboard.descriptions.2':
    'Con le dashboard personalizzate di {{shortBrandName}} potrai...',
  'dashboard.checks.0': 'Scopri dove vengono spesi i tuoi soldi e perché',
  'dashboard.checks.1': 'Scopri quale risorsa costa di più e perché',
  'dashboard.checks.2': 'Crea i tuoi KPI personalizzati.',
  'dashboard.checks.3':
    'Visualizza report generati e aggiornati automaticamente in base alle tue metriche',
  'dashboard.checks.4':
    "Visualizza report facilmente condivisibili tramite fogli Excel, PDF o all'interno di {{shortBrandName}}",
  'dashboard.checks.5': 'E molto altro ancora...',
  'home.smarter': 'Più intelligente',
  'home.work': 'Lavoro',
  'home.smarter_description':
    '{{shortBrandName}} semplifica notevolmente il lavoro efficiente dei tecnici, consentendo loro di accedere agli strumenti e ai dati necessari per svolgere il proprio lavoro, il tutto dal palmo della loro mano.',
  leading_maintenance:
    "Aprire la strada a un futuro migliore per la manutenzione e l'affidabilità",
  premium_included: 'Funzionalità premium incluse',
  no_credit_card: 'Non è richiesta la carta di credito',
  perfect_tool: 'Lo strumento perfetto per i team di manutenzione',
  start_trial_today: 'Inizia oggi la tua prova gratuita',
  create_account: 'Creare un account',
  signup_description: 'Compila i campi sottostanti per creare un account.',
  account_already: 'Hai già un account?',
  signin_here: 'Accedi qui',
  invalid_email:
    "L'indirizzo email fornito deve essere un indirizzo email valido",
  required_email: 'Il campo email è obbligatorio',
  required_firstName: 'Il campo nome è obbligatorio',
  required_lastName: 'Il campo cognome è obbligatorio',
  required_company: 'Il campo nome azienda è obbligatorio',
  required_employeesCount: 'Si prega di fornire il numero di dipendenti',
  invalid_phone: 'Il numero di telefono non è valido',
  required_password: 'Il campo password è obbligatorio',
  required_terms: 'Devi accettare i nostri termini e condizioni',
  verify_email: 'Controlla la tua email per attivare il tuo account',
  registration_error: 'La registrazione non è riuscita',
  first_name: 'Nome di battesimo',
  last_name: 'Cognome',
  email: 'Indirizzo e-mail',
  phone: 'Telefono',
  password: 'Password',
  companyName: "Nome dell'azienda",
  employeesCount: 'Numero di dipendenti',
  i_accept: 'Accetto il',
  terms_conditions: 'Termini e Condizioni',
  create_your_account: 'Crea il tuo account',
  register: 'Registro',
  login_description: 'Compila i campi sottostanti per accedere al tuo account.',
  no_account_yet: 'Non hai ancora un account?',
  signup_here: 'Iscriviti qui',
  wrong_credentials: 'Sono state fornite credenziali errate',
  lost_password: 'Password dimenticata?',
  link_wo: 'Collega gli ordini di lavoro',
  link_wo_description: 'Creare relazioni tra ordini di lavoro',
  required_relationType: 'Seleziona il tipo di relazione.',
  required_wo: 'Il campo Ordine di lavoro è obbligatorio.',
  this_wo: 'Questo ordine di lavoro',
  the_wo: "L'ordine di lavoro",
  link: 'Collegamento',
  cost_description: 'Descrizione dei costi',
  assigned_to: 'Assegnato a',
  category: 'Categoria',
  date: 'Data',
  cost: 'Costo',
  include_cost: 'Includi questo costo nel costo totale',
  include_cost_description:
    "Ciò aggiungerà il costo al costo totale speso per l'ordine di lavoro",
  required_cost_description: 'La descrizione del costo è obbligatoria',
  required_cost: 'Il costo è richiesto',
  add_cost: 'Aggiungi costo aggiuntivo',
  add_cost_description:
    'Compila i campi sottostanti per creare e aggiungere un costo aggiuntivo',
  add: 'Aggiungere',
  hourly_rate: 'Tariffa oraria',
  include_time: 'Includi questo tempo nel tempo totale',
  include_time_description:
    "Ciò aggiungerà la durata al tempo totale impiegato sull'ordine di lavoro",
  work_started_at: 'Lavoro iniziato alle',
  duration: 'Durata',
  hours: 'Ore',
  minutes: 'Minuti',
  required_hours: 'Il campo Ore è obbligatorio',
  required_minutes: 'Il campo Minuti è obbligatorio',
  add_time: 'Aggiungi tempo',
  add_time_description:
    'Compila i campi sottostanti per creare e aggiungere Tempo',
  feedback: 'Feedback',
  feedback_description: 'Dai il tuo feedback',
  required_feedback: 'È richiesto un feedback',
  signature: 'Firma',
  required_signature: "L'immagine è obbligatoria",
  close_wo: 'Chiudi ordine di lavoro',
  close: 'Vicino',
  task_update_success: 'Attività aggiornata con successo',
  task_update_failure: "Impossibile aggiornare l'attività",
  notes_save_success: 'Note salvate correttamente',
  images_add_task_success: "Le immagini sono state aggiunte all'attività",
  images_add_task_failure: 'Qualcosa è andato storto',
  images: 'Immagini',
  required_images: "Per favore carica almeno un'immagine",
  add_images: 'Aggiungi immagini',
  tasks: 'Compiti',
  wo_archive_success: "L'ordine di lavoro è stato archiviato",
  wo_archive_failure: "L'ordine di lavoro non può essere archiviato",
  wo_archive_confirm: 'Sei sicuro di voler archiviare questo ordine di lavoro?',
  quantity_change_success: 'Quantità modificata con successo',
  quantity_change_failure: 'La quantità non può essere modificata',
  details: 'Dettagli',
  updates: 'Aggiornamenti',
  id: 'ID',
  due_date: 'Due Date',
  location: 'Posizione',
  asset: 'Risorsa',
  team: 'Squadra',
  created_at: 'Data di creazione',
  list_view: 'Visualizzazione elenco',
  calendar_view: 'Visualizzazione calendario',
  column_view: 'Vista colonna',
  wo_create_success: "L'ordine di lavoro è stato creato correttamente",
  wo_create_failure: "Non è stato possibile creare l'ordine di lavoro",
  changes_saved_success: 'Le modifiche sono state salvate',
  wo_update_failure: "L'ordine di lavoro non può essere modificato",
  wo_delete_success: "L'ordine di lavoro è stato eliminato correttamente",
  wo_delete_failure: "Impossibile eliminare l'ordine di lavoro",
  status: 'Stato',
  title: 'Titolo',
  priority: 'Priorità',
  description: 'Descrizione',
  worker: 'Lavoratore',
  location_name: 'Nome della posizione',
  location_address: 'Indirizzo della posizione',
  asset_name: 'Nome della risorsa',
  days_since_creation: 'Giorni dalla creazione',
  files: 'File',
  requested_by: 'Richiesto da',
  completed_on: 'Completato il',
  updated_at: 'Aggiornato alle',
  work_order: 'Ordine di lavoro',
  timer_running: 'Timer in esecuzione',
  run_timer: 'Timer di esecuzione',
  approved_by: 'Approvato da',
  created_by: 'Creato da',
  completed_by: 'Completato da',
  time: 'Tempo',
  save: 'Salva',
  customers: 'Appaltatori',
  no_labor:
    'Non sono ancora stati aggiunti costi di manodopera. Verranno visualizzati qui quando un utente registra il tempo e ha una tariffa oraria memorizzata in {{shortBrandName}}.',
  not_assigned: 'Non assegnato',
  no_additional_cost: 'Non sono stati ancora aggiunti costi aggiuntivi',
  parts: 'Parti',
  links: 'Collegamenti',
  confirm_delete_file_wo:
    'Sei sicuro di voler rimuovere questo file da questo ordine di lavoro?',
  archive: 'Archivio',
  labors: 'Fatiche',
  add_additional_cost: 'Aggiungi costo aggiuntivo',
  additional_costs: 'Costi aggiuntivi',
  add_parts: 'Aggiungi parti',
  'wo.title_description': "Inserisci il titolo dell'ordine di lavoro",
  image: 'Immagine',
  estimated_duration: 'Durata stimata in ore',
  primary_worker: 'Lavoratore primario',
  additional_workers: 'Lavoratori aggiuntivi',
  select_team: 'Seleziona la squadra',
  select_location: 'Seleziona la posizione',
  select_asset: 'Seleziona risorsa',
  select_tasks: 'Seleziona attività',
  requires_signature: 'Richiede la firma',
  required_wo_title: "Il titolo dell'ordine di lavoro è obbligatorio",
  add_wo: 'Aggiungi ordine di lavoro',
  add_wo_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo ordine di lavoro',
  edit_wo: 'Modifica ordine di lavoro',
  edit_wo_description:
    "Compila i campi sottostanti per aggiornare l'Ordine di Lavoro",
  'noRows.wo.message':
    'Gli ordini di lavoro sono attività o lavori che possono essere programmati o assegnati a qualcuno',
  'noRows.wo.action': "Premere il pulsante '+' per creare un ordine di lavoro",
  to_delete: 'Eliminare',
  confirm_delete_wo: 'Sei sicuro di voler eliminare questo ordine di lavoro?',
  no_access_wo:
    'Non hai accesso agli Ordini di Lavoro. Contatta il tuo amministratore se dovresti averne accesso.',
  cancel: 'Cancellare',
  select_parts: 'Seleziona parti',
  sets_of_parts: 'Set di parti',
  paused: 'In pausa',
  trigger_details: 'Dettagli del trigger',
  starts_on: 'Inizia su',
  ends_on: 'Termina il',
  frequency: 'Frequenza',
  every_frequency_days: 'Ogni {{frequenza}} giorni',
  wo_details: "Dettagli dell'ordine di lavoro",
  confirm_delete_file: 'Sei sicuro di voler rimuovere questo file?',
  wo_schedule_success: 'Ordine di lavoro pianificato con successo',
  wo_schedule_failure: "Non è stato possibile pianificare l'ordine di lavoro",
  wo_trigger_edit_failure:
    "Non è stato possibile modificare il trigger dell'ordine di lavoro",
  wo_trigger_delete_success:
    "Il trigger dell'ordine di lavoro è stato eliminato correttamente",
  wo_trigger_delete_failure:
    "Impossibile eliminare il trigger dell'ordine di lavoro",
  name: 'Nome',
  wo_title: "Titolo dell'ordine di lavoro",
  next_wo: 'Prossimo ordine di lavoro',
  trigger_name: 'Nome trigger',
  enter_trigger_name: 'Inserisci il nome del trigger',
  frequency_description: 'Frequenza in giorni',
  wo_configuration: "Configurazione dell'ordine di lavoro",
  required_trigger_name: 'Il nome del trigger è obbligatorio',
  required_frequency: 'La frequenza di trigger è richiesta',
  invalid_frequency: 'La frequenza deve essere superiore a 0',
  schedule_wo: "Pianifica l'ordine di lavoro",
  schedule_wo_description:
    'Compila i campi sottostanti per pianificare un ordine di lavoro',
  edit_wo_trigger: 'Modifica trigger ordine di lavoro',
  edit_wo_trigger_description:
    "Compila i campi sottostanti per modificare il trigger dell'ordine di lavoro",
  create_trigger: 'Crea trigger',
  'noRows.pm.message':
    'Pianifica gli ordini di lavoro con trigger personalizzati',
  'noRows.pm.action': "Premi il pulsante '+' per creare un trigger",
  confirm_delete_pm:
    'Sei sicuro di voler eliminare questo trigger di ordine di lavoro?',
  no_access_pm:
    'Non hai accesso alla sezione Manutenzione preventiva. Contatta il tuo amministratore se dovresti averne accesso.',
  enter_wo_title: "Inserisci il titolo dell'ordine di lavoro",
  status_report: 'Rapporto sullo stato',
  wo_analysis: "Analisi dell'ordine di lavoro",
  wo_aging: 'Invecchiamento degli ordini di lavoro',
  time_and_cost: 'Tempo e costi',
  assets: 'Attività',
  reliability_dashboard: 'Dashboard di affidabilità',
  total_maintenance_cost: 'Costo totale di manutenzione',
  useful_life: 'Vita utile',
  requests: 'Richieste',
  locations: 'Posizioni',
  parts_and_inventory: 'Parti/inventario',
  purchase_orders: 'Ordini di acquisto',
  meters: 'metri',
  people_teams: 'Persone e team',
  people: 'Persone',
  teams: 'Squadre',
  vendors_customers: 'Fornitori e appaltatori',
  vendors: 'Fornitori',
  categories: 'Categorie',
  settings: 'Impostazioni',
  cancelled: 'Annullato',
  reject: 'Rifiutare',
  approve: 'Approvare',
  request_create_success: 'Ordine di lavoro richiesto con successo',
  request_create_failure: 'Non è stato possibile creare la richiesta di lavoro',
  request_edit_failure: 'La richiesta non può essere modificata',
  request_delete_success: 'La richiesta è stata eliminata con successo',
  request_delete_failure: 'La richiesta non può essere eliminata',
  rejected: 'Respinto',
  approved: 'Approvato',
  pending: 'In attesa di',
  required_request_name: 'Il titolo della richiesta è obbligatorio',
  required_field: 'Questo campo è obbligatorio',
  add_request: 'Aggiungi richiesta',
  add_request_description:
    'Compila i campi sottostanti per creare e aggiungere una nuova richiesta',
  edit_request: 'Modifica richiesta',
  edit_request_description:
    'Compila i campi sottostanti per modificare la richiesta',
  'noRows.request.message': 'Gestisci le tue richieste di lavoro',
  'noRows.request.action':
    "Premi il pulsante '+' per creare una richiesta di lavoro",
  confirm_delete_request: 'Sei sicuro di voler eliminare questa richiesta?',
  request: 'Richiesta',
  request_details: 'Richiedi dettagli',
  none_priority: 'Nessuno',
  low_priority: 'Basso',
  medium_priority: 'Medio',
  high_priority: 'Alto',
  downtimes: 'Tempi di inattività',
  confirm_delete_file_asset:
    'Sei sicuro di voler rimuovere questo file da questa risorsa?',
  actions: 'Azioni',
  show: 'Spettacolo',
  model: 'Modello',
  serial_number: 'Numero di serie',
  operational: 'Operativo',
  down: 'Giù',
  area: 'Zona',
  barcode: 'Codice a barre',
  placed_in_service: 'Messo in servizio',
  warranty_expiration: 'Scadenza della garanzia',
  asset_information: 'Informazioni sulle risorse',
  more_informations: 'Maggiori informazioni',
  confirm_delete_asset_downtime:
    'Sei sicuro di voler rimuovere questo periodo di inattività?',
  create_downtime_success:
    'Il tempo di inattività è stato aggiunto con successo',
  create_downtime_failure:
    'Non è stato possibile aggiungere il tempo di inattività',
  edit_downtime_success:
    'Il tempo di inattività è stato modificato con successo',
  started_on: 'Iniziato il',
  required_startsOn: 'La data di inizio è obbligatoria',
  reading_create_success: 'La lettura è stata aggiunta con successo',
  reading_create_failure: 'La lettura non può essere aggiunta',
  reading: 'Lettura',
  added_by: 'Aggiunto da',
  enter_meter_value: 'Inserisci il valore del contatore',
  add_reading: 'Aggiungi lettura',
  select_meter: 'Seleziona contatore',
  confirm_delete_part_asset:
    'Sei sicuro di voler rimuovere questa parte da questa risorsa?',
  no_due_date: 'No Due Date',
  due_at_date: 'Due {{date}}',
  no_primary_worker: 'Nessun lavoratore primario',
  no_wo_linked_asset:
    'Non esiste alcun ordine di lavoro collegato a questa risorsa',
  asset_remove_success: 'La risorsa è stata eliminata correttamente',
  asset_remove_failure: 'Impossibile eliminare la risorsa',
  asset_name_description: 'Inserisci il nome della risorsa',
  select_asset_location: 'Seleziona la posizione della risorsa',
  primary_user_description: "Seleziona l'utente principale",
  teams_description: 'Seleziona le squadre',
  customers_description: 'Seleziona appaltatori',
  vendors_description: 'Seleziona i fornitori',
  inServiceDate_description: 'Data di messa in servizio',
  warranty_expiration_date: 'Data di scadenza della garanzia',
  additional_information: 'Informazioni aggiuntive',
  structure: 'Struttura',
  parent_asset: 'Risorsa principale',
  asset_create_success: 'La risorsa è stata creata correttamente',
  asset_create_failure: 'Impossibile creare la risorsa',
  additional_workers_description: 'Seleziona lavoratori aggiuntivi',
  required_asset_name: 'Il nome della risorsa è obbligatorio',
  add_asset: 'Aggiungi risorsa',
  add_asset_description:
    'Compila i campi sottostanti per creare e aggiungere una nuova risorsa',
  create_asset: 'Crea risorsa',
  hierarchy: 'Gerarchia',
  add_downtime: 'Aggiungi tempi di inattività',
  edit_downtime: 'Modifica tempo di inattività',
  remove_downtime: 'Rimuovi i tempi di inattività',
  edit: 'Modificare',
  edit_asset: 'Modifica risorsa',
  edit_asset_description:
    'Compila i campi sottostanti per modificare questa risorsa',
  confirm_delete_asset: 'Sei sicuro di voler eliminare questa risorsa?',
  loading_assets: 'Caricamento delle risorse in {{name}} #{{id}}',
  no_content: 'Nessun contenuto',
  no_result_criteria: 'Nessun risultato corrisponde ai tuoi criteri di ricerca',
  map_view: 'Vista mappa',
  location_create_success: 'La posizione è stata creata con successo',
  location_create_failure: 'Non è stato possibile creare la posizione',
  location_edit_failure: 'La posizione non può essere modificata',
  location_delete_success: 'La posizione è stata eliminata con successo',
  location_delete_failure: 'La posizione non può essere eliminata',
  enter_location_name: 'Inserisci il nome della posizione',
  address: 'Indirizzo',
  parent_location: 'Posizione del genitore',
  select_workers: 'Seleziona i lavoratori',
  map_coordinates: 'Coordinate della mappa',
  required_location_name: 'Il titolo della posizione è obbligatorio',
  required_location_address: "L'indirizzo della posizione è obbligatorio",
  add_location: 'Aggiungi posizione',
  add_location_description:
    'Compila i campi sottostanti per creare e aggiungere una nuova posizione',
  edit_location: 'Modifica posizione',
  edit_location_description:
    'Compila i campi sottostanti per aggiornare la posizione',
  confirm_delete_location: 'Sei sicuro di voler eliminare questa posizione?',
  floor_plans: 'Planimetrie',
  floor_plan: 'Planimetria',
  floor_plan_name_description: 'Nome della planimetria',
  'Floor plan area in m²': 'Superficie della planimetria in m²',
  upload_image: "Carica un'immagine",
  required_floor_plan_name: 'Il nome della planimetria è obbligatorio',
  add_floor_plan: 'Aggiungi nuova planimetria',
  add_floor_plan_description:
    'Compila i campi sottostanti per creare una nuova planimetria',
  no_asset_in_location: 'Nessuna risorsa in questa posizione',
  no_wo_in_location: 'Nessun ordine di lavoro in questa posizione',
  no_file_in_location: 'Nessun file allegato a questa posizione',
  no_floor_plan_in_location: 'Nessuna planimetria in questa posizione',
  assigned_teams: 'Squadre assegnate',
  assigned_customers: 'Appaltatori assegnati',
  assigned_vendors: 'Fornitori assegnati',
  no_access_location:
    'Non hai accesso alle Posizioni. Contatta il tuo amministratore se dovresti avere accesso.',
  no_access_vendors_customers:
    'Non hai accesso a Fornitori e Appaltatori. Contatta il tuo amministratore se dovresti avere accesso.',
  no_access_people_team:
    'Non hai accesso a Persone e Team. Contatta il tuo amministratore se dovresti avere accesso.',
  no_access_analytics:
    'Non hai accesso ad Analytics. Contatta il tuo amministratore se dovresti averne accesso.',
  no_access_assets:
    'Non hai accesso alle risorse. Contatta il tuo amministratore se dovresti averne accesso.',
  no_access_categories:
    'Non hai accesso alle Categorie. Contatta il tuo amministratore se dovresti avere accesso.',
  no_access_files:
    "Non hai accesso ai file. Contatta l'amministratore se dovresti averne accesso.",
  no_access_inventory:
    "Non hai accesso all'inventario. Contatta il tuo amministratore se dovresti averne accesso.",
  no_access_meters:
    'Non hai accesso ai contatori. Contatta il tuo amministratore se dovresti averne accesso.',
  no_access_purchase_orders:
    'Non puoi creare un ordine di acquisto. Contatta il tuo amministratore se hai accesso.',
  no_access_requests:
    'Non hai accesso alle Richieste. Contatta il tuo amministratore se dovresti averne accesso.',
  no_access_settings:
    "Non hai accesso alle impostazioni. Contatta l'amministratore se dovresti avere accesso.",
  no_access_page: 'Non hai accesso a questa pagina',
  file: 'File',
  'noRows.location.message':
    'Le posizioni consentono di gestire in modo più efficiente risorse e lavoratori',
  'noRows.location.action': "Premi il pulsante '+' per creare una posizione",
  card_view: 'Vista della scheda',
  set_create_success: 'Il set è stato creato con successo',
  set_create_failure: 'Il set non può essere creato',
  set_edit_failure: 'Il set non può essere modificato',
  set_delete_success: 'Il set è stato eliminato con successo',
  set_delete_failure: 'Il set non può essere eliminato',
  total_cost: 'Costo totale',
  part: 'Parte',
  enter_part_name: 'Inserisci il nome della parte',
  required_set_name: 'Il nome del set è obbligatorio',
  add_set: 'Aggiungi set',
  add_set_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo set',
  create_set: 'Crea set',
  edit_set: 'Modifica set',
  edit_set_description: 'Compila i campi sottostanti per modificare il Set',
  confirm_delete_set: 'Sei sicuro di voler eliminare questo set?',
  part_create_success: 'La parte è stata creata con successo',
  part_create_failure: 'La parte non può essere creata',
  part_edit_failure: 'La parte non può essere modificata',
  part_delete_success: 'La parte è stata eliminata correttamente',
  part_delete_failure: 'La parte non può essere eliminata',
  quantity: 'Quantità',
  open_wo: 'Ordini di lavoro aperti',
  enter_part_category: 'Inserisci la categoria della parte',
  enter_part_cost: 'Inserisci il costo della parte',
  enter_part_quantity: 'Inserisci la quantità della parte',
  minimum_quantity: 'Quantità minima',
  enter_part_minimum_quantity: 'Inserisci la quantità minima della parte',
  non_stock: 'Non disponibile in magazzino',
  enter_part_barcode: 'Inserisci il codice a barre della parte',
  enter_part_area: "Inserisci l'area della parte",
  additional_part_details: 'Dettagli aggiuntivi sulla parte',
  add_part: 'Aggiungi parte',
  add_part_description:
    'Compila i campi sottostanti per creare e aggiungere una nuova parte',
  create_part: 'Crea parte',
  update_part: 'Aggiorna parte',
  update_part_description:
    'Compila i campi sottostanti per aggiornare la Parte',
  'noRows.part.message':
    'Le parti possono essere combinate in risorse o utilizzate singolarmente',
  'noRows.part.action': "Premere il pulsante '+' per creare una parte",
  confirm_delete_part: 'Sei sicuro di voler eliminare questa parte?',
  part_details: 'Dettagli della parte',
  area_details: "Dettagli dell'area",
  assigned_people: 'Persone assegnate',
  no_asset_related_part: 'Nessuna risorsa correlata a questa parte',
  no_file_found: 'Nessun file trovato',
  no_wo_found: 'Nessun ordine di lavoro trovato',
  workers: 'Lavoratori',
  Parts_and_Inventory: 'Parti e inventario',
  po_edit_failure: "L'ordine di acquisto non può essere modificato",
  po_delete_success: "L'ordine di acquisto è stato eliminato correttamente",
  po_delete_failure: "L'ordine di acquisto non può essere eliminato",
  number_of_items: 'Numero di articoli',
  total_quantity: 'Quantità totale',
  shipping_to: 'Spedizione a',
  shipping_address: 'Indirizzo di spedizione',
  po_details: "Dettagli dell'ordine di acquisto",
  enter_po_name: "Inserisci il nome dell'ordine di acquisto",
  additional_details: 'Dettagli aggiuntivi',
  vendor: 'Venditore',
  shipping_information: 'Informazioni sulla spedizione',
  company_name: "Nome dell'azienda",
  ship_to: 'Spedire a',
  city: 'Città',
  state: 'Stato',
  zip_code: 'Cap',
  fax_number: 'Numero di fax',
  po_date: "Data dell'ordine di acquisto",
  notes: 'Note',
  add_notes: 'Aggiungi note',
  requisitioner: 'Richiedente',
  terms: 'Termini',
  shipping_method: 'Metodo di spedizione',
  required_name: 'Il nome è obbligatorio',
  edit_po: 'Modifica ordine di acquisto',
  edit_po_description:
    "Compila i campi sottostanti per aggiornare l'Ordine di Acquisto",
  purchase_order: "Ordinazione d'acquisto",
  'noRows.po.message': 'Gestisci i tuoi ordini di acquisto in un unico posto',
  'noRows.po.action':
    "Premere il pulsante '+' per creare un ordine di acquisto.",
  confirm_delete_po: 'Sei sicuro di voler eliminare questo ordine di acquisto?',
  upgrade_po: 'Aggiorna per creare ordini di acquisto',
  new_po: 'Nuovo ordine di acquisto',
  po_create_success: "L'ordine di acquisto è stato creato con successo",
  select_one_part: 'Seleziona almeno 1 parte',
  po_create_failure: "Non è stato possibile creare l'ordine di acquisto",
  approve_while_submitting: "Approva durante l'invio",
  invalid_fax: 'Il numero di fax non è valido',
  submit: 'Invia',
  each_item_superior_zero:
    'La quantità di ogni articolo deve essere superiore a 0',
  quantity_edit_success: 'Quantità modificata con successo',
  quantity_edit_failure: 'La quantità non può essere modificata',
  APPROVED: 'Approvato',
  PENDING: 'In attesa di',
  REJECTED: 'Respinto',
  when_reading_is: 'Quando la lettura del contatore è',
  greater_than: 'Maggiore di',
  lower_than: 'Inferiore a',
  value: 'Valore',
  required_value: 'Il valore è obbligatorio',
  required_trigger_condition: 'La condizione è richiesta',
  wo_trigger_create_success:
    "Il trigger dell'ordine di lavoro è stato creato correttamente",
  wo_trigger_create_failure:
    "Non è stato possibile creare il trigger dell'ordine di lavoro",
  add_wo_trigger: 'Aggiungi trigger ordine di lavoro',
  add_wo_trigger_description:
    'Compila i campi sottostanti per creare e aggiungere un trigger di ordine di lavoro',
  wo_trigger_edit_success:
    "Il trigger dell'ordine di lavoro è stato aggiornato correttamente",
  meter_create_success: 'Il contatore è stato creato con successo',
  meter_create_failure: 'Non è stato possibile creare il contatore',
  meter_edit_failure: 'Il contatore non può essere modificato',
  meter_delete_success: 'Il contatore è stato eliminato con successo',
  meter_delete_failure: 'Il contatore non può essere eliminato',
  next_reading_due: 'Prossima lettura prevista',
  unit_of_measurement: 'Unità di misura',
  last_reading: 'Ultima lettura',
  enter_meter_name: 'Inserisci il nome del contatore',
  unit: 'Unità',
  update_frequency: 'Frequenza di aggiornamento',
  update_frequency_in_days: 'Frequenza di aggiornamento in giorni',
  required_meter_name: 'Il nome del contatore è obbligatorio',
  required_meter_unit: "È richiesta l'unità di misura",
  required_meter_update_frequency:
    'È richiesta la frequenza di aggiornamento del contatore',
  required_asset: 'La risorsa è obbligatoria',
  add_meter: 'Aggiungi contatore',
  add_meter_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo contatore',
  edit_meter: 'Modifica contatore',
  edit_meter_description:
    'Compila i campi sottostanti per modificare il contatore',
  confirm_delete_meter: 'Sei sicuro di voler eliminare questo contatore?',
  upgrade_create_meter: 'Aggiorna per creare contatori',
  history: 'Storia',
  reading_frequency: 'Frequenza di lettura',
  required_reading_value: 'È richiesto il valore di lettura',
  wo_triggers: 'Trigger degli ordini di lavoro',
  add_trigger: 'Aggiungi trigger',
  meter_details: 'Dettagli del contatore',
  'noRows.meter.message':
    'Le letture dei contatori ti danno la possibilità di monitorare le risorse e di attivare nuovi ordini di lavoro in base a condizioni definite',
  'noRows.meter.action': "Premi il pulsante '+' per creare un contatore",
  meter: 'metro',
  drag_one_file: 'Trascina qui un file univoco',
  drag_many_files: 'Trascina e rilascia i file qui',
  drop_to_start: 'Rilascia i file per iniziare il caricamento',
  invalid_files_type: 'Non puoi caricare questi tipi di file',
  you_have_uploaded: 'Hai caricato',
  upload: 'Caricamento',
  Vendors_Customers: 'Fornitori e appaltatori',
  customer_create_success: 'Il contraente è stato creato con successo',
  customer_create_failure: 'Non è stato possibile creare il contraente',
  customer_edit_failure: "L'appaltatore non può essere modificato",
  customer_delete_success: "L'appaltatore è stato eliminato con successo",
  customer_delete_failure: "Non è stato possibile eliminare l'appaltatore",
  customer_name: 'Nome del contraente',
  website: 'Sito web',
  customer_type: 'Tipo di appaltatore',
  customer_type_description: 'es. Idraulica, Elettricità',
  customer_description_description:
    'Descrivi in poche righe lo scopo di questo appaltatore...',
  billing_information: 'Informazioni di fatturazione',
  address_line_2: 'Indirizzo riga 2',
  billing_name: 'Nome di fatturazione',
  currency: 'Valuta',
  select_currency: 'Seleziona valuta',
  required_customer_name: 'Il nome del contraente è obbligatorio',
  required_phone: 'Il numero di telefono è obbligatorio',
  invalid_website: 'Sito web non valido',
  billing_address: 'Indirizzo di fatturazione',
  add_customer: 'Aggiungi appaltatore',
  add_customer_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo appaltatore',
  'noRows.customer.message': 'I contraenti sono lavoratori esterni',
  'noRows.customer.action': "Premere il pulsante '+' per creare un appaltatore",
  type: 'Tipo',
  billing_currency: 'Valuta di fatturazione',
  go_back: 'Torna indietro',
  confirm_delete_customer: 'Sei sicuro di voler eliminare questo contraente?',
  vendor_create_success: 'Il fornitore è stato creato con successo',
  vendor_create_failure: 'Non è stato possibile creare il fornitore',
  vendor_edit_failure: 'Il fornitore non può essere modificato',
  vendor_delete_success: 'Il fornitore è stato eliminato correttamente',
  vendor_delete_failure: 'Il fornitore non può essere eliminato',
  required_company_name: "Il nome dell'azienda è obbligatorio",
  vendor_type: 'Tipo di fornitore',
  contact_name: 'Nome del contatto',
  add_vendor: 'Aggiungi fornitore',
  add_vendor_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo fornitore',
  confirm_delete_vendor: 'Sei sicuro di voler eliminare questo fornitore?',
  'noRows.vendor.message':
    'I fornitori sono organizzazioni che forniscono beni o parti',
  'noRows.vendor.action': "Premi il pulsante '+' per creare un fornitore",
  vendor_type_description: 'es. Idraulica, Elettricità',
  role: 'Ruolo',
  edit_user: 'Modifica utente',
  edit_user_description: "Compila i campi sottostanti per modificare l'utente",
  job_title: 'Titolo di lavoro',
  invite_users: 'Invita utenti',
  bring_people_team: 'Portare nuove persone nel team',
  add_20_users:
    'È possibile aggiungere 20 utenti alla volta premendo "Tab" o "Invio" dopo ogni inserimento di un indirizzo email. Eventuali indirizzi email duplicati e registrati verranno rimossi durante la registrazione degli utenti richiesti.',
  enter_email: "Inserisci l'indirizzo email",
  users_invite_success: 'Gli utenti sono stati invitati',
  users_invite_failure:
    'Gli utenti non possono essere invitati. Controlla il numero attuale dei membri del tuo abbonamento.',
  please_type_emails: 'Inserisci gli indirizzi email per invitare',
  please_select_role: 'Seleziona un ruolo',
  invite: 'Invitare',
  team_create_success: 'Il Team è stato creato con successo',
  team_create_failure: 'Non è stato possibile creare il team',
  team_edit_failure: 'Il team non può essere modificato',
  team_delete_success: 'Il team è stato eliminato con successo',
  team_delete_failure: 'Il team non può essere eliminato',
  team_name: 'Nome della squadra',
  people_in_team: 'Persone nel team',
  required_team_name: 'Il nome della squadra è obbligatorio',
  create_team: 'Crea una squadra',
  create_team_description: 'Puoi aggiungere membri del team da qui',
  confirm_delete_team: 'Sei sicuro di voler eliminare questo Team?',
  overview: 'Panoramica',
  activity: 'Attività',
  wo_complete_last_14_days:
    'Ordini di lavoro completati negli ultimi 14 giorni',
  no_wo_complete_last_14_days:
    'Non hai completato alcun ordine di lavoro nelle ultime due settimane',
  ADMIN_name: 'Amministratore',
  ADMIN_description:
    "L'amministratore ha accesso completo, inclusa la modifica, l'aggiunta e l'eliminazione di ordini di lavoro e richieste",
  LIMITED_ADMIN_name: 'Amministratore limitato',
  LIMITED_ADMIN_description:
    'Gli amministratori limitati hanno lo stesso accesso degli amministratori, ma non possono visualizzare/modificare le impostazioni o aggiungere/modificare persone e team. Non possono eliminare ordini di lavoro, posizioni di asset, contatori e ordini di acquisto, a meno che non abbiano creato trigger per appaltatori, categorie e progetti di manutenzione preventiva.',
  TECHNICIAN_name: 'Tecnico',
  TECHNICIAN_description:
    'I tecnici possono creare e chiudere ordini di lavoro, risorse e ubicazioni. Possono modificare ed eliminare solo ciò che hanno creato.',
  LIMITED_TECHNICIAN_name: 'Tecnico limitato',
  LIMITED_TECHNICIAN_description:
    'I tecnici limitati possono vedere solo gli ordini di lavoro assegnati loro',
  VIEW_ONLY_name: 'Solo visualizzazione',
  VIEW_ONLY_description:
    'Gli utenti di sola visualizzazione hanno accesso completo alla visualizzazione, ma non possono modificare nulla',
  REQUESTER_name: 'Richiedente',
  REQUESTER_description:
    'I richiedenti possono solo inviare richieste di lavoro e visualizzarne lo stato',
  select_user_role: 'Seleziona il ruolo utente',
  'noRows.team.message':
    'I team ti aiutano a gestire gruppi specifici di persone.',
  'noRows.team.action': "Premi il pulsante '+' per creare una squadra.",
  user_details: 'Dettagli utente',
  file_delete_success: 'Il file è stato eliminato correttamente',
  file_delete_failure: 'Il file non può essere eliminato',
  uploaded_by: 'Caricato da',
  uploaded_on: 'Caricato il',
  rename: 'Rinominare',
  required_files: 'Si prega di caricare almeno un file',
  required_file_name: 'Inserisci un nome file',
  add_files: 'Aggiungi file',
  edit_file: 'Modifica file',
  'noRows.file.message': 'Ottieni tutti i file in un unico posto',
  'noRows.file.action': "Premi il pulsante '+' per caricare un file",
  upgrade_files:
    "Esegui l'aggiornamento per utilizzare i file nelle tue risorse, ordini di lavoro, posizioni ecc.",
  parts_consumption: 'Consumo di parti',
  requests_analysis: 'Analisi della richiesta',
  category_create_success: 'La categoria è stata creata con successo',
  category_create_failure: 'La categoria non può essere creata',
  category_edit_failure: 'La categoria non può essere modificata',
  category_delete_success: 'La categoria è stata eliminata con successo',
  category_delete_failure: 'La categoria non può essere eliminata',
  timers: 'Timer',
  costs: 'Costi',
  add_category: 'Aggiungi nuova categoria',
  add_category_description:
    'Inserisci il nome per creare e aggiungere una nuova categoria',
  edit_category: 'Modifica categoria',
  edit_category_description: 'Inserisci il nome per modificare la categoria',
  no_category_action:
    "Premi il pulsante '+' per aggiungere la tua prima categoria.",
  confirm_delete_category: 'Sei sicuro di voler eliminare questa categoria?',
  no_category_message:
    'Sembra che non ci siano ancora categorie {{categoryName}}.',
  acquisition_cost: 'Costo di acquisizione',
  general_settings: 'Impostazioni generali',
  request_form_configuration: 'Configurazione del modulo di richiesta',
  roles: 'Ruoli',
  checklists: 'Liste di controllo',
  field_configuration_description:
    'È possibile contrassegnare i campi come facoltativi, nascosti o obbligatori',
  optional: 'Opzionale',
  required: 'Necessario',
  hidden: 'Nascosto',
  creating_wo: 'Creazione di un ordine di lavoro',
  completing_wo: 'Completamento di un ordine di lavoro',
  role_edit_failure: 'Il ruolo non può essere modificato',
  edit_role: 'Modifica ruolo',
  edit_role_description: 'Compila i campi sottostanti per modificare il ruolo',
  external_id: 'ID esterno',
  permissions: 'Permessi',
  create_role_description:
    'Questo ruolo può svolgere tutte le funzioni di un amministratore in {{brandName}}, ma puoi personalizzare alcune autorizzazioni importanti di seguito.',
  create_and_edit: 'Crea/Modifica',
  to_access: 'Accesso',
  role_delete_success: 'Il ruolo è stato eliminato correttamente',
  role_delete_failure: 'Il ruolo non può essere eliminato',
  confirm_delete_role:
    'Sei sicuro di voler eliminare definitivamente questo ruolo?',
  users: 'Utenti',
  paid: 'Pagato',
  free: 'Gratuito',
  role_create_success: 'Il ruolo è stato creato con successo',
  role_create_failure: 'Il ruolo non può essere creato',
  roles_management: 'Gestione dei ruoli',
  roles_number: '{{count}} ruoli',
  create_role: 'Crea ruolo',
  upgrade_role: 'Aggiorna per creare un ruolo',
  add_role: 'Aggiungi nuovo ruolo',
  add_role_description:
    'Compila i campi sottostanti per creare e aggiungere un nuovo ruolo',
  parts_and_sets: 'Parti e set di parti',
  upgrade_role_edit: 'Aggiorna per modificare il ruolo',
  delete_role: 'Elimina ruolo',
  upgrade_role_delete: 'Aggiorna per eliminare il ruolo',
  create: 'Creare',
  pm_trigger: 'Trigger di manutenzione preventiva',
  auto_assign_wo: 'Assegnazione automatica degli ordini di lavoro',
  auto_assign_wo_description:
    'Assegna automaticamente nuovi ordini di lavoro alla persona che li crea',
  auto_assign_requests: 'Assegnazione automatica delle richieste',
  auto_assign_requests_description:
    'Assegna automaticamente nuovi ordini di lavoro alla persona che approva la richiesta',
  disable_closed_wo_notification:
    'Disabilita le notifiche degli ordini di lavoro chiusi',
  disable_closed_wo_notification_description:
    'Disattiva le notifiche quando gli ordini di lavoro chiusi vengono aggiornati',
  ask_feedback_wo_closed:
    "Richiedi un feedback quando l'ordine di lavoro è chiuso",
  ask_feedback_wo_closed_description:
    'Agli utenti viene chiesto di fornire un feedback sul lavoro svolto',
  include_labor_in_total_cost: 'Includere il costo del lavoro nel costo totale',
  include_labor_in_total_cost_description:
    'Aggiungere i costi di manodopera al totale quando un utente registra il tempo e ha una tariffa oraria memorizzata',
  enable_wo_updates_requesters:
    'Abilita gli aggiornamenti degli ordini di lavoro per i richiedenti',
  enable_wo_updates_requesters_description:
    'Gli utenti ricevono aggiornamenti per gli ordini di lavoro richiesti',
  language: 'Lingua',
  date_format: 'Formato data',
  business_type: 'Tipo di attività',
  general_asset_management: 'Gestione patrimoniale generale',
  physical_asset_management: 'Gestione delle risorse fisiche',
  checklist_delete_success: 'La checklist è stata eliminata con successo',
  checklist_delete_failure: 'Impossibile eliminare la checklist',
  create_checklist: 'Crea una lista di controllo',
  confirm_delete_checklist: 'Sei sicuro di voler eliminare questa Checklist?',
  upgrade_checklist: "Effettua l'aggiornamento per utilizzare le checklist",
  upgrade_now: 'Aggiorna ora',
  total: 'Totale',
  sub_task_status: 'Stato del sotto-compito',
  text_field: 'Campo di testo',
  number_field: 'Campo numerico',
  inspection_check: 'Controllo di ispezione',
  multiple_choices: 'Scelte multiple',
  meter_reading: 'Lettura del contatore',
  select_user: 'Seleziona utente',
  PASS: 'Passaggio',
  FLAG: 'Bandiera',
  FAIL: 'Fallire',
  enter_task_name: "Inserisci un nome per l'attività",
  see_details: 'Vedi i dettagli',
  concerned_asset: 'Asset interessato',
  me: 'Me',
  remove_blank_tasks: 'Rimuovi le attività vuote',
  remove_blank_options: 'Rimuovi le opzioni vuote',
  preview: 'Anteprima',
  edit_checklist: 'Modifica la lista di controllo',
  add_tasks: 'Aggiungi attività',
  use_a_checklist: 'Utilizzare una lista di controllo',
  select_checklist: 'Seleziona la lista di controllo',
  save_checklist: 'Salva la lista di controllo',
  assign_tasks_description:
    'Assegna attività personalizzate da compilare ai tecnici',
  select_date: 'Seleziona la data',
  task: 'Compito',
  checklist: 'Lista di controllo',
  upgrade_analytics: "Esegui l'upgrade per vedere Analytics",
  grouped_by_category: 'Raggruppati per categoria',
  downtime_by_asset: 'Tempo di inattività per risorsa',
  downtime_and_costs: 'Tempi di inattività e costi',
  downtime_and_costs_trends: 'Tendenze dei tempi di inattività e dei costi',
  downtimes_trends: 'Tendenze dei tempi di inattività',
  repair_time_by_asset: 'Tempo di riparazione per risorsa',
  consumed_parts_costs: 'Costi delle parti consumate',
  requests_by_priority: 'Richieste per priorità',
  requests_trends: 'Tendenze delle richieste',
  time_spent: 'Tempo trascorso',
  grouped_by_completed_by: 'Raggruppati per Completato da',
  grouped_by_assigned_to: 'Raggruppati per Assegnato a',
  grouped_by_priority: 'Raggruppati per priorità',
  completion_comparison: 'Confronto di completamento',
  hours_worked: 'Ore lavorate',
  work_remaining: 'Lavoro rimanente',
  wo_status: "Stato dell'ordine di lavoro",
  cost_trends: 'Andamento dei costi',
  cost_center: 'Analisi dei costi del ciclo di vita delle risorse',
  downtime_and_availability: 'Tempi di inattività e disponibilità',
  incomplete_wo: 'Ordini di lavoro incompleti',
  the_numbers: 'I numeri',
  hours_and_cost_by_asset: 'Ore e costi per risorsa',
  completion_comparison_description:
    'Confronto tra vari tipi di ordini di lavoro completati.',
  wo_age_description:
    "L'età dell'ordine di lavoro è definita come il numero di giorni trascorsi tra la creazione dell'ordine di lavoro (o richiesta di lavoro) e il suo completamento.",
  rav_description:
    "Il costo totale come % del RAV è uguale a (costo degli ordini di lavoro sull'asset / prezzo di acquisto) * 100. Lo standard del settore è un valore target del 3% per questa metrica",
  downtime_and_availability_description:
    "La disponibilità si riferisce alla percentuale di risorse in stato operativo dalla data di messa in servizio. I tempi di inattività totali si riferiscono al numero di eventi di inattività verificatisi durante l'intervallo di date specificato.",
  total_cost_description:
    'Il costo totale include il costo della manodopera, il costo aggiuntivo e il costo dei componenti in un ordine di lavoro',
  compliant_wo_description:
    'Gli ordini di lavoro conformi sono definiti come ordini di lavoro completati prima della data di scadenza. Il tempo di ciclo si riferisce al numero di giorni necessari per il completamento di un ordine di lavoro.',
  hours_worked_description:
    "Queste ore corrispondono agli ordini di lavoro che hanno una data di scadenza compresa nell'intervallo specificato nei filtri.",
  work_remaining_description:
    "Questo grafico mostra il numero di ordini di lavoro incompleti in scadenza nell'intervallo di date specificato nei filtri. Le ore stimate corrispondono a quei singoli ordini di lavoro.",
  total_downtime_in_hours: 'Tempo di inattività totale (ore)',
  downtime_events: 'Eventi di inattività',
  percent_downtime: '% Tempo di inattività',
  meantime_between_failures_in_hours: 'Tempo medio tra guasti (ore)',
  availability_percent: 'Percentuale di disponibilità',
  mean_time_to_repair_in_hours: 'Tempo medio di riparazione (ore)',
  average_age: 'Età media',
  count: 'Contare',
  average_cost: 'Costo medio',
  compliant: 'Compiacente',
  average_cycle_time_in_days: 'Tempo medio del ciclo (giorni)',
  total_consumption_cost: 'Costo totale del consumo',
  parts_consumed: 'Parti consumate',
  total_cost_as_pct_rav: 'Costo totale in percentuale del RAV',
  approved_requests: 'Richieste approvate',
  pending_requests: 'Richieste in sospeso',
  cancelled_requests: 'Richieste annullate',
  average_cycle_time: 'Tempo medio del ciclo',
  compliance_rate: 'Tasso di conformità',
  complete: 'Completare',
  reactive: 'Reattivo',
  recurring: 'Ricorrente',
  part_costs: 'Costi parziali',
  labor_costs: 'Costo del lavoro',
  total_time_spent_in_hours: 'Tempo totale trascorso (ore)',
  estimated_hours: 'Ore stimate',
  total_purchase_price: 'Prezzo totale di acquisto',
  you_have: 'Hai',
  new_messages: 'nuovi messaggi',
  company: 'Azienda',
  change_cover: 'Cambia copertina',
  required_address: 'Il campo indirizzo è obbligatorio',
  company_details: "Dettagli dell'azienda",
  company_details_description:
    'Gestisci le informazioni relative alla tua azienda',
  learn_more: 'Saperne di più',
  profile: 'Profilo',
  email_notifications: 'Notifiche e-mail',
  email_updates_wo: 'Aggiornamenti via e-mail per ordini di lavoro e messaggi',
  email_updates_requests:
    'Aggiornamenti via e-mail per gli ordini di lavoro richiesti',
  po_emails: 'Email di ordini di acquisto',
  required_job_title: 'Il campo Titolo del lavoro è obbligatorio',
  required_old_password: 'Inserisci la password attuale.',
  invalid_password:
    'La password è troppo corta: dovrebbe contenere almeno 8 caratteri.',
  required_new_password: 'Nessuna password fornita.',
  passwords_must_match: 'Le password devono essere identiche',
  password_change_success: 'Password modificata con successo',
  wrong_password: 'Password errata fornita',
  current_password: 'Password attuale',
  new_password: 'Nuova password',
  confirm_password: 'Conferma password',
  personal_details: 'Dati personali',
  personal_details_description:
    'Gestisci le informazioni relative ai tuoi dati personali',
  change_password: 'Cambiare la password',
  notification_settings: 'Impostazioni delle notifiche',
  notification_settings_description:
    'Gestisci i dettagli relativi alle tue notifiche',
  recent_activity: 'Attività recenti',
  created: 'Creato',
  completed: 'Completato',
  my_account: 'Il mio conto',
  my_company: 'La mia azienda',
  you_are_using_plan:
    "Al momento stai utilizzando il piano {{planName}}. Scadrà il giorno {{expiration}}. Esegui l'upgrade ora per accedere a più funzionalità.",
  upgrade_plan: 'Piano di aggiornamento',
  plans: 'Piani',
  monthly: 'Mensile',
  annually: 'Annualmente',
  subscription_change_success: "L'abbonamento è stato modificato con successo",
  invalid_credit_card: 'Il numero della carta di credito non è valido',
  required_credit_card: 'Il campo carta è obbligatorio',
  invalid_expiration_month: 'Il mese di scadenza non è valido',
  required_expiration_month: 'Il mese di scadenza è obbligatorio',
  invalid_expiration_year: "L'anno di scadenza non è valido",
  required_expiration_year: "L'anno di scadenza è obbligatorio",
  invalid_cvv: 'Il CVV non è valido',
  required_cvv: 'Il CVV è obbligatorio',
  required_cardholder_name: 'Il nome del titolare della carta è obbligatorio',
  card: 'Carta',
  expiration_month: 'Mese di scadenza',
  expiration_year: 'Anno di scadenza',
  cardholder_name: 'Nome del titolare',
  seats: 'Posti a sedere',
  cost_per_seat: 'Costo per posto',
  your_payment_secure: 'I tuoi dati di pagamento sono crittografati e sicuri.',
  plan: 'Piano',
  current_plan: 'Piano attuale',
  number_users_who_will_use_grash:
    'Numero di utenti che utilizzeranno {{shortBrandName}}',
  admin_role: 'Amministratore',
  technical_role: 'Tecnico',
  limited_technical_role: 'Tecnico limitato',
  requester_role: 'Richiedente',
  view_only_role: 'Solo visualizzazione',
  how_will_you_be_billed: 'Come preferisci essere fatturato?',
  which_plan_fits_you: 'Quale piano è più adatto a te?',
  per_user_month: 'per utente/mese',
  per_user_year: 'per utente/anno',
  you_will_be_charged: 'Ti verrà addebitato',
  proceed_to_payment: 'Procedi al pagamento',
  pay_only_for_roles:
    'Paga solo per gli utenti <strong>Admin</strong> , <strong>Technical</strong> e <strong>Limited Technical</strong> e usa <strong>Requester</strong> illimitato, <strong>View-Only</strong> gratuitamente',
  checkout_our: "Dai un'occhiata al nostro",
  pricing_page: 'Pagina dei prezzi',
  for_more_details: 'per maggiori dettagli',
  users_count_display: '{{count}} utenti',
  monthly_adverb: 'mensile',
  yearly_adverb: 'annuale',
  features: 'Caratteristiche',
  checkout: 'Guardare',
  checkout_description: 'Compila i campi sottostanti',
  per_month: 'al mese',
  per_year: "all'anno",
  recover_password_description:
    "Inserisci l'email utilizzata per la registrazione per reimpostare la password.",
  send_me_new_password: 'Inviami una nuova password',
  want_to_sign_in_again: 'Vuoi provare ad accedere di nuovo?',
  check_mails_for_instructions:
    'Controlla la tua email per ulteriori istruzioni',
  pdf_report: 'Rapporto PDF',
  HIGH: 'Alto',
  MEDIUM: 'Medio',
  LOW: 'Basso',
  NONE: 'Nessuno',
  import: 'Importare',
  start_import_process: 'Avvia il processo di importazione',
  import_data: 'Importa dati',
  set_header: 'Imposta intestazione',
  match_columns: 'Colonne di corrispondenza',
  review: 'Revisione',
  done: 'Fatto',
  no_match_yet: 'Nessuna corrispondenza ancora',
  select: 'Selezionare...',
  matched_to_field: 'Corrisponde a {{field}}',
  next: 'Prossimo',
  not_enough_rows: 'Non ci sono abbastanza righe nel file',
  there_are_duplicates: 'Ci sono duplicati: {{duplicates}}',
  assigned_by: 'Assegnato da',
  percent_rows_have_value: '{{percent}}% delle righe hanno valore',
  match_at_least_column: 'Corrisponde almeno a una colonna',
  to_import: 'Importare',
  required_match: 'È richiesta la corrispondenza {{field}}',
  archived: 'Archiviato',
  import_wo_success:
    '{{created}} Ordini di lavoro sono stati creati e {{updated}} sono stati aggiornati',
  to_export: 'Esportare',
  filters: 'Filtri',
  more_filters: 'Altri filtri',
  customer: 'Contraente',
  to: 'A',
  dates: 'Date',
  start: 'Inizio',
  end: 'FINE',
  longitude: 'Longitudine',
  latitude: 'Latitudine',
  ALL: 'Tutto',
  REACTIVE: 'Reattivo',
  REPEATING: 'Preventivo',
  import_location_success:
    '{{created}} Le posizioni sono state create e {{updated}} sono state aggiornate',
  import_part_success:
    '{{created}} Le parti sono state create e {{updated}} sono state aggiornate',
  import_meter_success:
    'I contatori {{created}} sono stati creati e {{updated}} sono stati aggiornati',
  import_asset_success:
    '{{created}} Le risorse sono state create e {{updated}} sono state aggiornate',
  wo_calendar: 'Calendario degli ordini di lavoro',
  month: 'Mese',
  week: 'Settimana',
  day: 'Giorno',
  agenda: 'Ordine del giorno',
  previous: 'Precedente',
  today: 'Oggi',
  to_filter: 'Filtro',
  'noRows.asset.message':
    'Le risorse sono risorse su cui la tua azienda può intervenire',
  'noRows.asset.action': "Premi il pulsante '+' per creare una nuova risorsa.",
  reset_filters: 'Reimposta filtri',
  toggle_menu: 'Attiva/disattiva menu',
  no_results: 'Nessun risultato trovato',
  an_error_occured: 'Si è verificato un errore.',
  density: 'Densità',
  compact: 'Compatto',
  standard: 'Standard',
  comfortable: 'Comodo',
  columns: 'Colonne',
  select_columns: 'Seleziona colonne',
  show_filters: 'Mostra filtri',
  hide_filters: 'Nascondi filtri',
  search_placeholder: 'Ricerca…',
  search: 'Ricerca',
  clear: 'Chiaro',
  download_as_csv: 'Scarica come CSV',
  print: 'Stampa',
  download_as_excel: 'Scarica come Excel',
  find_column: 'Trova colonna',
  column_title: 'Titolo della colonna',
  reorder_column: 'Riordina colonna',
  show_all: 'Mostra tutto',
  hide_all: 'Nascondi tutto',
  add_filter: 'Aggiungi filtro',
  logic_operator: 'Operatore logico',
  operator: 'Operatore',
  and: 'E',
  or: 'O',
  filter_value: 'Valore del filtro',
  contains: 'contiene',
  equals: 'è uguale',
  starts_with: 'inizia con',
  ends_with: 'finisce con',
  is: 'È',
  is_not: 'non è',
  is_after: 'è dopo',
  is_on_or_after: 'è acceso o dopo',
  is_before: 'è prima',
  is_on_or_before: 'è acceso o prima',
  is_empty: 'è vuoto',
  is_not_empty: 'non è vuoto',
  is_any_of: 'è uno qualsiasi di',
  any: 'Qualunque',
  true_text: 'VERO',
  false_text: 'falso',
  menu: 'Menu',
  show_columns: 'Mostra colonne',
  hide: 'Nascondere',
  unsort: 'Non ordinare',
  sort_by_ASC: 'Ordina per ASC',
  sort_by_DESC: 'Ordina per DESC',
  sort: 'Ordinare',
  total_rows: 'Numero totale di righe:',
  yes: 'SÌ',
  no: 'NO',
  more: 'Di più',
  to_group: 'Gruppo',
  see_children: 'vedere i bambini',
  hide_children: 'nascondere i bambini',
  expand: 'Espandere',
  collapse: 'Crollo',
  detail_panel_toggle: 'Attiva/disattiva pannello dettagli',
  cancel_subscription: 'Annulla abbonamento',
  resume_subscription: "Riprendi l'abbonamento",
  confirm_cancel_subscription: "Sei sicuro di voler annullare l'abbonamento?",
  workflows: 'Flussi di lavoro',
  create_workflow: 'Crea flusso di lavoro',
  if: 'Se',
  and_optional: 'E (facoltativo)',
  then: 'Poi',
  workflow_description:
    'Crea flussi di lavoro personalizzati con la stessa facilità di "Se", "E", "Allora". Risparmia tempo e assegna automaticamente i tuoi ordini di lavoro tramite flussi di lavoro per personalizzare {{shortBrandName}} in base alle esigenze del tuo team.\nTutti i piani consentono di creare fino a 1 flusso di lavoro personalizzato. Per aggiungere altri flussi di lavoro, esegui l\'upgrade al nostro piano Business.',
  CREATE_PURCHASE_ORDER: 'Crea un ordine di acquisto',
  PART_IS: 'La parte è',
  QUANTITY_INFERIOR: 'La quantità è inferiore a',
  ASSIGN_VENDOR: 'Assegna il fornitore',
  ASSIGN_CATEGORY: 'Assegna la categoria',
  APPROVE: 'Approvare',
  REJECT: 'Rifiutare',
  SEND_REMINDER_EMAIL: 'Invia email di promemoria',
  VENDOR_IS: 'Il venditore è',
  CATEGORY_IS: 'La categoria è',
  STATUS_IS: 'Lo stato è',
  DUE_DATE_BETWEEN: 'La data di scadenza è compresa tra',
  DUE_DATE_AFTER: 'La data di scadenza è successiva',
  ASSIGN_PRIORITY: 'Assegna la priorità',
  ASSIGN_ASSET: 'Assegna la risorsa',
  ASSIGN_LOCATION: 'Assegna la posizione',
  ASSIGN_USER: "Assegna l'utente",
  ASSIGN_TEAM: 'Assegna la squadra',
  ADD_CHECKLIST: 'Aggiungi lista di controllo',
  PRIORITY_IS: 'La priorità è',
  ASSET_IS: 'La risorsa è',
  LOCATION_IS: 'La posizione è',
  USER_IS: "L'utente è",
  TEAM_IS: 'La squadra è',
  CREATED_AT_BETWEEN: 'Si crea tra',
  TITLE_CONTAINS: 'Il titolo contiene',
  CREATE_REQUEST: 'Crea una richiesta',
  CREATE_WORK_ORDER: 'Crea un ordine di lavoro',
  SET_ASSET_STATUS: 'Imposta lo stato delle risorse',
  NAME_IS: 'Il nome è',
  NAME_CONTAINS: 'Il nome contiene',
  VALUE_IS: 'Il valore è',
  VALUE_CONTAINS: 'Il valore contiene',
  NUMBER_VALUE_SUPERIOR: 'Il valore è superiore a',
  NUMBER_VALUE_INFERIOR: 'Il valore è inferiore a',
  WORK_ORDER_CREATED: 'Viene creato un ordine di lavoro',
  WORK_ORDER_CLOSED: 'Un ordine di lavoro è chiuso',
  WORK_ORDER_ARCHIVED: 'Un ordine di lavoro è archiviato',
  REQUEST_CREATED: 'Viene creata una richiesta',
  REQUEST_APPROVED: 'Una richiesta è approvata',
  REQUEST_REJECTED: 'Una richiesta è stata respinta',
  PURCHASE_ORDER_CREATED: 'Viene creato un ordine di acquisto',
  PURCHASE_ORDER_UPDATED: 'Un ordine di acquisto è aggiornato',
  TASK_UPDATED: "Un'attività è aggiornata",
  PART_UPDATED: 'Una parte è aggiornata',
  add_condition: 'Aggiungi condizione',
  workflow_creation_success: 'Flusso di lavoro creato con successo',
  workflow_creation_failure: 'La creazione del flusso di lavoro non è riuscita',
  action_value_missing: "Manca il valore dell'azione",
  condition_value_missing: 'Manca un valore di condizione',
  workflow_edit_success: 'Il flusso di lavoro è stato aggiornato con successo',
  workflow_edit_failure: 'Il flusso di lavoro non può essere modificato',
  workflow_delete_success:
    'Il flusso di lavoro è stato eliminato correttamente',
  workflow_delete_failure: 'Impossibile eliminare il flusso di lavoro',
  confirm_delete_workflow:
    'Sei sicuro di voler eliminare questo flusso di lavoro?',
  click_here: 'clicca qui',
  verify_email_title: 'Verifica email',
  verify_email_description:
    "Ti è stata inviata un'email di verifica. Controlla la posta indesiderata se non la trovi nella posta in arrivo.",
  upgrade: 'Aggiornamento',
  downgrade: 'Declassare',
  upgrade_description:
    "Hai appena aggiornato il tuo piano di abbonamento. Devi abilitare gli utenti disabilitati che potrebbero utilizzare {{shortBrandName}}. Puoi farlo solo una volta per l'abbonamento corrente. Scegli con attenzione.",
  enable_users: 'Abilita gli utenti',
  max_users_description: 'Puoi abilitare fino a {{maxUsers}} utenti',
  downgrade_description:
    "Hai appena effettuato il downgrade del tuo piano di abbonamento. Devi disabilitare alcuni utenti per procedere. Puoi farlo solo una volta per l'abbonamento corrente. Scegli con attenzione.",
  disable_users: 'Disabilitare gli utenti',
  min_users_description: 'Devi disabilitare almeno {{minUsers}} utenti',
  downgrade_description_no_owner:
    "La tua azienda ha appena effettuato il downgrade del suo piano di abbonamento. Il proprietario dell'azienda deve disabilitare alcuni utenti prima che tu possa procedere.",
  past_due: 'Scaduto',
  due_date_delay: 'Ritardo della data di scadenza',
  due_date_delay_description: 'Ritardo della data di scadenza in giorni',
  days_count: '{{giorni}} giorni',
  trigger_configuration: 'Configurazione del trigger',
  WORK_ORDER_feature: 'Ordini di lavoro',
  REQUEST_feature: 'Richieste di lavoro',
  PART_feature: 'Gestione delle parti',
  MOBILE_APP_feature: 'Applicazione mobile',
  WORK_ORDER_HISTORY_feature: 'Cronologia degli ordini di lavoro',
  PREVENTIVE_MAINTENANCE_feature: 'Manutenzione preventiva',
  CHECKLIST_feature: 'Liste di controllo',
  FILE_feature: 'Caricamento file',
  PURCHASE_ORDER_feature: 'Ordini di acquisto',
  METER_feature: 'Letture del contatore',
  REQUEST_CONFIGURATION_feature: 'Configurazione del modulo di richiesta',
  ADDITIONAL_TIME_feature: 'Monitoraggio avanzato del tempo',
  ADDITIONAL_COST_feature: 'Monitoraggio avanzato dei costi',
  ANALYTICS_feature: 'Analisi e reporting',
  REQUEST_PORTAL_feature: 'Portale di richiesta',
  SIGNATURE_feature: 'Firme',
  ROLE_feature: 'Ruoli personalizzati',
  WORKFLOW_feature: 'Automazione del flusso di lavoro',
  API_ACCESS_feature: 'Accesso API',
  WEBHOOK_feature: 'Webhook',
  add_new_option: 'Aggiungi nuova opzione',
  edit_company: 'Modifica azienda',
  fill_fields_below: 'Compila i campi sottostanti',
  IMPORT_CSV_feature: 'Importazione CSV',
  no_import_access: 'Aggiorna il tuo piano per importare da file CSV ed Excel',
  members: 'Membri',
  assign_user: 'Assegna utente',
  assign_asset: 'Assegna risorsa',
  required_files_on_completion:
    "I file sono richiesti al completamento dell'ordine di lavoro",
  required_tasks_on_completion: 'I compiti devono essere completati',
  required_labor_on_completion: 'Devi registrare il tempo',
  required_part_on_completion:
    'Nessuna parte è stata utilizzata in questo ordine di lavoro',
  required_cost_on_completion:
    'Nessuna informazione sui costi fornita in questo ordine di lavoro',
  estimated_hours_in_text: '{{hours}} ore stimate',
  required_part_name: 'Il nome della parte è obbligatorio',
  asset_update_failure: 'La risorsa non può essere modificata',
  terms_of_service: 'Termini di servizio',
  privacy_policy: 'Politica sulla riservatezza',
  last_login: 'Ultimo accesso',
  not_enough_part: "Non c'è abbastanza di questa parte",
  remove_blank_meter_tasks:
    'Rimuovi attività con tipo misuratore senza misuratore',
  checklist_update_failure: 'La checklist non può essere modificata',
  contact_us: 'Contattaci',
  simplify_wo: "Semplifica gli ordini di lavoro nell'app mobile",
  simplify_wo_description:
    "Nascondi i controlli del tempo, i costi e le parti nei dettagli dell'ordine di lavoro durante l'utilizzo dell'app mobile",
  account_deletion: "Eliminazione dell'account {{brandName}}",
  switch_account: 'Cambia account',
  switch_to_super_user: 'Passa a super amministratore',
  switch_account_description: 'Si prega di scegliere un account per procedere',
  put_location_in_map: 'Inserisci la posizione sulla mappa',
  confirm_disable_user:
    'Sei sicuro di voler disattivare {{user}}? Potrai abilitarlo solo dopo un mese.',
  user_disabled_success: 'Utente disabilitato con successo',
  disable: 'Disabilitare',
  manufacturer: 'Produttore',
  power: 'Energia',
  import_error: "L'importazione non è riuscita",
  request_upgrade: "Richiedi l'aggiornamento",
  operation_success: "L'operazione è un successo",
  CANCELLED: 'Respinto',
  uptime_hours: 'Tempo di attività (h)',
  downtime_hours: 'Tempo di inattività (h)',
  mark_all_as_seen: 'Segna tutto come visto',
  estimation_accuracy_ratio: 'Rapporto di accuratezza della stima',
  download_template: 'Scarica il modello',
  pareto_by_total_price: 'Pareto per prezzo totale',
  cumulative_percent: 'Percentuale cumulativa',
  part_consumption_by_asset: 'Consumo parziale per asset',
  grouped_by_wo_category: 'Raggruppati per categoria di ordine di lavoro',
  resolution_rate: 'Tasso di risoluzione',
  resolved: 'Risolto',
  average: 'Media',
  documentation: 'Documentazione',
  days_before_pm_notification: 'Notifiche di ordini di lavoro pre-programmati',
  estimated_start_date: 'Data di inizio prevista',
  no_file_linked_to_wo: 'Nessun file allegato a questo ordine di lavoro',
  add_file: 'Aggiungi file',
  try_for_free: 'Prova gratuitamente',
  choose_your_plan: 'Scegli il tuo piano',
  STARTER_description:
    'Team che desiderano realizzare una manutenzione preventiva efficace e solida attraverso la visibilità dello stato delle macchine e della manodopera.',
  PROFESSIONAL_description:
    "Dipartimenti che hanno bisogno di sfruttare informazioni e analisi per favorire un'ulteriore crescita della manutenzione e della produttività.",
  BUSINESS_description:
    'Organizzazioni pronte ad acquisire dati di manutenzione e operativi per gestire più sedi e la personalizzazione del sistema.',
  book_demo: 'Prenota una demo',
  request_pricing: 'Richiedi un preventivo per maggiori informazioni',
  Reports: 'Rapporti',
  'Custom dashboard built using the included components':
    'Dashboard personalizzata creata utilizzando i componenti inclusi',
  Export: 'Esportare',
  'Last year': "L'anno scorso",
  Expenses: 'Spese',
  Statistics: 'Statistiche',
  General: 'Generale',
  Calendar: 'Calendario',
  Mailbox: 'cassetta postale',
  Dashboards: 'Dashboard',
  Analytics: 'Analisi',
  Monitoring: 'Monitoraggio',
  Tasks: 'Compiti',
  Applications: 'Applicazioni',
  Users: 'Utenti',
  'List All': 'Elenca tutto',
  'User Profile': 'Profilo utente',
  Login: 'Login',
  Register: 'Registro',
  'Recover Password': 'Recupera password',
  Status: 'Stato',
  'Error 404': 'Errore 404',
  'Error 500': 'Errore 500',
  'Coming Soon': 'Prossimamente',
  Maintenance: 'Manutenzione',
  Overview: 'Panoramica',
  Documentation: 'Documentazione',
  Welcome: 'Benvenuto',
  Help: 'Aiuto',
  'Features tour': 'Tour delle caratteristiche',
  'Getting started guide': 'Guida introduttiva',
  'Contact support': "Contatta l'assistenza",
  Version: 'Versione',
  Search: 'Ricerca',
  Notifications: 'Notifiche',
  Settings: 'Impostazioni',
  'Language Switcher': 'Selettore di lingua',
  'Sign out': 'disconnessione',
  'Change Theme': 'Cambia tema',
  'View all notifications': 'Visualizza tutte le notifiche',
  rate: 'valutare',
  select_at_least_column: 'Seleziona almeno una colonna',
  already_read: 'Già letto',
  OPERATIONAL: 'Operativo',
  DOWN: 'Giù',
  MODERNIZATION: 'Modernizzazione',
  STANDBY: 'Stand-by',
  INSPECTION_SCHEDULED: 'Ispezione programmata',
  COMMISSIONING: 'Messa in servizio',
  EMERGENCY_SHUTDOWN: 'Arresto di emergenza',
  select_asset_status: 'Seleziona lo stato della risorsa',
  asset_status: 'Stato delle risorse',
  ui_configuration: "Configurazione dell'interfaccia utente",
  password_leave_empty_if_you_dont_want_to_change:
    'Password: lascia vuoto se non vuoi cambiarla',
  upgrade_request_success:
    'Richiesta di aggiornamento ricevuta! Ti contatteremo presto con i dettagli di pagamento',
  continue_with_sso: 'Continua con SSO',
  see_live_demo: 'Vedi demo dal vivo',
  days: 'Giorni',
  weeks: 'Settimane',
  months: 'Mesi',
  years: 'Anni',
  based_on: 'Basato su',
  scheduled_date: 'Data pianificata',
  on: 'Su',
  required_days_of_week: 'Giorni della settimana richiesti',
  'schedule.daily_one': 'Ogni {{count}} giorno',
  'schedule.daily_other': 'Ogni {{count}} giorni',
  'schedule.weekly_one': 'Ogni {{count}} settimana il {{days}}',
  'schedule.weekly_other': 'Ogni {{count}} settimane il {{days}}',
  'schedule.monthly_one': 'Ogni {{count}} mese',
  'schedule.monthly_other': 'Ogni {{count}} mesi',
  'schedule.yearly_one': 'Ogni {{count}} anno',
  'schedule.yearly_other': 'Ogni {{count}} anni'
};

export default locale;
